import { getNewsArticles, GetNewsArticlesResponse } from 'data/prismic';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';

export const useNews = ({
  params,
  initialData,
}: {
  params: { limit: number; afterCursor?: string };
  initialData?: GetNewsArticlesResponse;
}): UseInfiniteQueryResult<GetNewsArticlesResponse, string> =>
  useInfiniteQuery(
    ['news', params],
    ({ pageParam: afterCursor }) => getNewsArticles({ ...params, afterCursor }),
    {
      getNextPageParam: (lastGroup: GetNewsArticlesResponse) =>
        lastGroup?.hasNextPage ? lastGroup?.lastCursor : undefined,
      initialData: initialData && {
        pages: [initialData],
        pageParams: [undefined],
      },
    },
  );
